/**
 * Counts a number up from 0 when it scrolls into view (lac-stats section).
 * The server-rendered text is the final value, so the number is correct without
 * JavaScript and for users who prefer reduced motion.
 */
class LacCountUp extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.target = Number(this.dataset.value) || 0;
    if (this.target <= 0) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.#run();
        }
      },
      { threshold: 0.5 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  #format(value) {
    const separator = this.dataset.separator ?? '';
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  #run() {
    const duration = 1600;
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.textContent = this.#format(Math.round(this.target * eased));
      if (progress < 1) requestAnimationFrame(step);
    };
    this.textContent = this.#format(0);
    requestAnimationFrame(step);
  }
}

if (!customElements.get('lac-count-up')) {
  customElements.define('lac-count-up', LacCountUp);
}
